<div class="icon">
  <span nz-icon style="font-size: 16px" class="material-icons-outlined">open_in_full</span>
</div>
<img [ngStyle]="{ width: width }" [matTooltip]="'Click to view full size image.'" nz-image [nzSrc]="src" />
